export const OPERATIONS_URL = import.meta.env.VITE_OPERATIONS_WEBSITE_URL || "https://operations.sharepal.co.in";
export const TICKETING_URL = import.meta.env.VITE_TICKETING_WEBSITE_URL || "https://ticketing.sharepal.co";
